import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import HudModal from "./HudModal";
import { formatErr, inputCls, labelCls } from "../lib/constants";

const empty = { name: "", location: "", image: "" };

export default function HotelDialog({ open, hotel, onClose, onSaved }) {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setForm(hotel ? { name: hotel.name, location: hotel.location || "", image: hotel.image || "" } : empty); }, [open, hotel]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (hotel) await api.put(`/hotels/${hotel.code}`, form);
      else await api.post("/hotels", form);
      toast.success(hotel ? "Otel güncellendi" : "Otel eklendi");
      onSaved();
    } catch (err) { toast.error(formatErr(err)); }
    setSaving(false);
  };

  return (
    <HudModal open={open} onClose={onClose} title={hotel ? "Oteli Düzenle" : "Yeni Otel"} testid="hotel-dialog">
      <form onSubmit={save} className="space-y-3">
        <div><label className={labelCls}>Otel Adı</label><input data-testid="hf-name" required value={form.name} onChange={set("name")} className={inputCls} placeholder="Örn. Arsi Garden" /></div>
        <div><label className={labelCls}>Konum</label><input data-testid="hf-location" value={form.location} onChange={set("location")} className={inputCls} placeholder="Alanya / ..." /></div>
        <div><label className={labelCls}>Kapak Görseli URL</label><input data-testid="hf-image" type="url" value={form.image} onChange={set("image")} className={inputCls} placeholder="https://..." /></div>
        <div className="h-32 rounded-lg border border-cyan-500/20 bg-slate-950/60 bg-cover bg-center flex items-center justify-center" style={form.image ? { backgroundImage: `url(${form.image})` } : {}}>
          {!form.image && <span className="text-[10px] font-mono text-slate-500 uppercase tracking-widest">Görsel önizleme</span>}
        </div>
        <button data-testid="hf-save" disabled={saving} className="w-full btn-cyan py-2.5 rounded-lg font-mono text-xs uppercase tracking-widest disabled:opacity-50">
          {saving ? "Kaydediliyor..." : "Kaydet"}
        </button>
      </form>
    </HudModal>
  );
}
